const parseMaybeJsonObject = (value) => {
  if (typeof value !== 'string') return value
  const trimmed = value.trim()
  if (!trimmed.startsWith('{')) return value
  try {
    return JSON.parse(trimmed)
  } catch (error) {
    return value
  }
}

// A theme card renders its background from `backgroundImage.large` and its logo
// from `logo.thumbnail`, so a value that arrives as a bare url string — or as a
// JSON-stringified object (AHA-46623 records ~19% of stored rows in that shape)
// — shows no image and the card reads as a plain colour swatch. Coerce every
// shape to the object the card expects so custom themes render like official ones.
export const normaliseThemeImage = (image) => {
  const parsed = parseMaybeJsonObject(image)
  if (!parsed || typeof parsed !== 'string') return parsed
  return {
    thumbnail: parsed, large: parsed, xLarge: parsed, xxLarge: parsed, name: parsed,
  }
}

export const normaliseThemeImages = (presentationTheme) => {
  if (!presentationTheme) return presentationTheme
  return {
    ...presentationTheme,
    ...(presentationTheme.backgroundImage
      ? { backgroundImage: normaliseThemeImage(presentationTheme.backgroundImage) } : {}),
    ...(presentationTheme.logo ? { logo: normaliseThemeImage(presentationTheme.logo) } : {}),
  }
}
